<div *ngIf="loading" class="loading">
    <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
  </div>
<div *ngIf="!firstLoad && !uploadSection" class="list" [class.rtl]="currLang == 'ar'">
    <app-control-bar [listType]="listType" [selectedRows]="selectedCheckBoxes"></app-control-bar>
    <div [class]="filterStatus ? 'side-bar show' : 'side-bar'" [ngClass]="(currLang == 'en') ? 'left' : 'right'">
        <app-filter [listType]="listType"></app-filter>
    </div>
    <app-table-view *ngIf="listType!='pending-requests'" 
    [controls]="tableControls"
    [listType]="listType"
    [showExport]="false" 
    [showPrintQr]="false"
    [showMsgIcon]="true"
    [showDeleteIcon]="true"
    [showRegenerateQrIcon]="false"
    [showExportPreparingToaster]="false"
    [showExport]="true" 
    [selectedRows_from_component]="selectedCheckBoxes"
    (eventHandeler)="tableEventHandeler($event)"
    (generateExcel)="generateExcelFile()">
    </app-table-view>

    <!-- successPasswordResetModal -->
    <div class="back-drop" *ngIf="showSuccessPasswordResetModal">
        <div class="modal-container">
            <div class="modal-header">
                <span style="cursor: pointer;" (click)="closeModal()"> 
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path d="M22.5 7.5L7.5 22.5M22.5 22.5L7.5 7.5" stroke="#667085" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                </span>
            </div>
            <div class="modal-body">
                <div class="modal-content">
                    <div class="modal-content-header">
                        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="119" viewBox="0 0 120 119" fill="none">
                            <g clip-path="url(#clip0_2959_13573)">
                              <rect width="119" height="119" transform="translate(0.5)" fill="white"/>
                              <mask id="mask0_2959_13573" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="120" height="119">
                                <path d="M119.5 0H0.5V119H119.5V0Z" fill="white"/>
                              </mask>
                              <g mask="url(#mask0_2959_13573)">
                                <path d="M60 10.2271C87.1937 10.2271 109.273 32.3063 109.273 59.5C109.273 86.6937 87.1937 108.773 60 108.773C32.8063 108.773 10.7271 86.6937 10.7271 59.5C10.7271 32.3063 32.8063 10.2271 60 10.2271Z" stroke="#1EBF74" stroke-width="2.99997" stroke-linecap="round"/>
                                <path d="M79.8572 46.6927C77.4016 49.1483 54.0344 72.5155 54.0344 72.5155L39.9343 58.4154" stroke="#1EBF74" stroke-width="3.49996" stroke-linecap="round" stroke-linejoin="round"/>
                              </g>
                            </g>
                            <defs>
                              <clipPath id="clip0_2959_13573">
                                <rect width="119" height="119" fill="white" transform="translate(0.5)"/>
                              </clipPath>
                            </defs>
                          </svg>
                    </div>
                    <div class="modal-content-body">
                        <div class="title">
                                {{'staff-table.password-reset-successfully' | translate}}
                        </div>
                        <div class="description">
                            <span class="description-text">
                                {{'staff-table.password-reset-successfully-desc' | translate}} <span class="default-password">
                                    {{defaultPassword}}
                                </span> 
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<div *ngIf="staff.length === 0 && firstLoad && !uploadSection" class="no-staff">
    <label class="no-staff-header">{{'staff-table.not-added' | translate}}</label>
    <div class="no-staff-buttons">
        <button class="btn btn-primary upload" (click)="openUploadSection()">{{'staff-table.upload-sheet' |
            translate}}</button>
        <button class="btn btn-primary add" (click)="addStaff()">{{'staff-table.add-staff' | translate}}</button>
    </div>
</div>
<ng-container *ngIf="uploadSection" class="upload-section">
    <app-upload></app-upload>
</ng-container>
<ng-template #exportStaffModalContainer></ng-template>
<!-- <app-add-staff></app-add-staff> -->